import { Sort } from "../models/shipeezi.table";

export const handleSort = (sorts?: Sort[]) => {
  const sorting: Array<string[]> = [];

  if (sorts && sorts?.length > 0)
    sorts.forEach((sort) => sorting.push([sort.columnName, sort.direction]));

  return sorting;
};
